import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
  Modal
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { doAuditLog, getNewISTDateTime } from "../../Utils/saveHistoryAction";
import { showMyAlert } from "../../Utils/alertService";
import "./EmpDetails.css"

const AddEmployeeDetails = () => {
  const CertFieldRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [existingRecordId, setExistingRecordId] = useState(null);
  const [existingRecordData, setExistingRecordData] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [sectionStatus, setSectionStatus] = useState({
    basicInfo: false,
    contactDetails: false,
    employmentDetails: false,
    educationDetails: false,
    bankDetails: false,
    emergencyContact: false,
  });
  const photographInputRef = useRef(null);
  const signatureInputRef = useRef(null);
  const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
  const [showDesignationDropdown, setShowDesignationDropdown] = useState(false);
  const [showEmploymentTypeDropdown, setShowEmploymentTypeDropdown] = useState(false);
  const [workLocations, setWorkLocations] = useState([]);

  // Modal states
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const [managerSearchQuery, setManagerSearchQuery] = useState("");
  const [managerSearchResults, setManagerSearchResults] = useState([]);
  const [showManagerSearchResults, setShowManagerSearchResults] = useState(false);
  const [isSearchingManager, setIsSearchingManager] = useState(false);

  const companyKey = sessionStorage.getItem("companyKey")

  const location = useLocation();
  const { state } = location;
  const inputRefs = useRef({});

  const { date, time } = getNewISTDateTime();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingDropdownValue, setPendingDropdownValue] = useState({
    type: '',
    value: '',
    department: null
  });

  const [formData, setFormData] = useState({
    fullName: "",
    dateOfBirth: "",
    gender: "",
    maritalStatus: "",
    parentName: "",
    bloodGroup: "",
    nationality: "",
    personalMobile: "",
    alternateMobile: "",
    personalEmail: "",
    currentAddress: "",
    permanentAddress: "",
    jobTitle: "",
    department: "",
    reportingManager: "",
    reportingManagerEmpID: "",
    employeeId: "",
    dateOfJoining: "",
    workLocation: "",
    employmentType: "",
    probationPeriod: "",
    shiftTiming: "",
    basicSalary: "",
    allowances: "",
    deductions: "",
    netSalary: "",
    paymentMode: "",
    salaryFrequency: "",
    effectiveDate: "",
    highestQualification: "",
    university: "",
    yearOfPassing: "",
    specialization: "",
    certifications: "",
    previousCompany: "",
    previousDesignation: "",
    previousDuration: "",
    leavingReason: "",
    bankName: "",
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
    panNumber: "",
    aadhaarNumber: "",
    passportNumber: "",
    drivingLicense: "",
    voterId: "",
    emergencyContactName: "",
    emergencyRelation: "",
    emergencyMobile: "",
    emergencyAddress: "",
    userId: state?.userId,
    userMobile: state?.mobileNumber || "",
    photograph: "",
    photographFile: null,
    photographPreview: "",
    signature: "",
    signatureFile: null,
    signaturePreview: "",
    relievingLetter: "",
    updatedSection: "",
    sectionName: "",
    approvalStatus: "false",
    createdAt: date,
    createdTime: time,
  });

  const [certifications, setCertifications] = useState(
    formData.certifications ? JSON.parse(formData.certifications) : []
  );
  const [newCertification, setNewCertification] = useState({
    name: "",
    file: null,
    fileName: "",
  });

  const [certificateFiles, setCertificateFiles] = useState([]);
  const [uploadedCertificates, setUploadedCertificates] = useState([]);

  const [dropdownData, setDropdownData] = useState({
    departments: [],
    designations: [],
    employmentTypes: [],
  });
  const [availableDesignations, setAvailableDesignations] = useState([]);

  useEffect(() => {
    fetchDropdownData();
    fetchWorkLocations();
  }, [formData.department])

  const steps = [
    { id: 0, title: "Basic Info", key: "basicInfo", icon: "fas fa-user" },
    {
      id: 1,
      title: "Contact Details",
      key: "contactDetails",
      icon: "fas fa-address-book",
    },
    {
      id: 2,
      title: "Employment Details",
      key: "employmentDetails",
      icon: "fas fa-briefcase",
    },
    {
      id: 3,
      title: "Education Details",
      key: "educationDetails",
      icon: "fas fa-graduation-cap",
    },
    {
      id: 4,
      title: "Bank Details",
      key: "bankDetails",
      icon: "fas fa-university",
    },
    {
      id: 5,
      title: "Emergency Contact",
      key: "emergencyContact",
      icon: "fas fa-phone-alt",
    },
  ];

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(mobile);
  };

  const validatePAN = (pan) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(pan);
  };

  const validateAadhaar = (aadhaar) => {
    const aadhaarRegex = /^[0-9]{12}$/;
    return aadhaarRegex.test(aadhaar);
  };

  const validateIFSC = (ifsc) => {
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return ifscRegex.test(ifsc);
  };

  const validateAccountNumber = (accountNumber) => {
    const accountRegex = /^[0-9]{9,18}$/;
    return accountRegex.test(accountNumber);
  };

  const validateBasicInfo = () => {
    const errors = {};

    if (!formData.fullName.trim()) {
      errors.fullName = "Full Name is required";
    }

    if (!formData.employeeId.trim()) {
      errors.employeeId = "Employee ID is required";
    }

    if (!formData.dateOfBirth) {
      errors.dateOfBirth = "Date of Birth is required";
    }

    if (!formData.gender) {
      errors.gender = "Gender is required";
    }

    if (!formData.nationality.trim()) {
      errors.nationality = "Nationality is required";
    }

    return errors;
  };

  const validateContactDetails = () => {
    const errors = {};

    if (!formData.personalEmail.trim()) {
      errors.personalEmail = "Work Email is required";
    } else if (!validateEmail(formData.personalEmail)) {
      errors.personalEmail = "Please enter a valid email address";
    }

    if (!formData.personalMobile.trim()) {
      errors.personalMobile = "Mobile Number is required";
    } else if (!validateMobile(formData.personalMobile)) {
      errors.personalMobile = "Mobile number must be exactly 10 digits";
    }

    if (!formData.currentAddress.trim()) {
      errors.currentAddress = "Current Address is required";
    }

    if (!formData.permanentAddress.trim()) {
      errors.permanentAddress = "Permanent Address is required";
    }

    if (formData.alternateMobile && !validateMobile(formData.alternateMobile)) {
      errors.alternateMobile =
        "Alternate mobile number must be exactly 10 digits";
    }

    return errors;
  };

  const handlePhotographUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showMyAlert({
          type: "danger",
          title: "Invalid File Type",
          message: "Please select an image file for photograph",
          duration: 2500,
        });
        return;
      }
      const uniqueId = `photo_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const fileExtension = file.name.split(".").pop();
      const newFilename = `${uniqueId}.${fileExtension}`;
      const previewUrl = URL.createObjectURL(file);

      setFormData((prev) => ({
        ...prev,
        photograph: newFilename,
        photographFile: file,
        photographPreview: previewUrl
      }));
    }
  };

  const handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showMyAlert({
          type: "danger",
          title: "Invalid File Type",
          message: "Please select an image file for signature",
          duration: 2500,
        });
        return;
      }
      const uniqueId = `sign_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const fileExtension = file.name.split(".").pop();
      const newFilename = `${uniqueId}.${fileExtension}`;
      const previewUrl = URL.createObjectURL(file);

      setFormData((prev) => ({
        ...prev,
        signature: newFilename,
        signatureFile: file,
        signaturePreview: previewUrl
      }));
    }
  };

  useEffect(() => {
    return () => {
      if (formData.photographPreview) {
        URL.revokeObjectURL(formData.photographPreview);
      }
      if (formData.signaturePreview) {
        URL.revokeObjectURL(formData.signaturePreview);
      }
    };
  }, []);

  const validateEmploymentDetails = () => {
    const errors = {};

    if (!formData.jobTitle.trim()) {
      errors.jobTitle = "Designation is required";
    }

    if (!formData.department.trim()) {
      errors.department = "Department is required";
    }

    if (!formData.dateOfJoining) {
      errors.dateOfJoining = "Date of Joining is required";
    }

    if (!formData.workLocation.trim()) {
      errors.workLocation = "Work Location is required";
    }

    return errors;
  };

  const validateEducationDetails = () => {
    const errors = {};

    if (!formData.highestQualification.trim()) {
      errors.highestQualification = "Highest Qualification is required";
    }

    if (!formData.university.trim()) {
      errors.university = "University/Institute is required";
    }

    if (!formData.yearOfPassing) {
      errors.yearOfPassing = "Year of Passing is required";
    } else {
      const year = parseInt(formData.yearOfPassing);
      const currentYear = new Date().getFullYear();
      if (year < 1950 || year > currentYear + 5) {
        errors.yearOfPassing = `Year must be between 1950 and ${currentYear + 5
          }`;
      }
    }

    if (!formData.specialization.trim()) {
      errors.specialization = "Specialization is required";
    }

    return errors;
  };

  const validateBankDetails = () => {
    const errors = {};

    if (!formData.bankName.trim()) {
      errors.bankName = "Bank Name is required";
    }

    if (!formData.accountHolderName.trim()) {
      errors.accountHolderName = "Account Holder Name is required";
    }

    if (!formData.accountNumber.trim()) {
      errors.accountNumber = "Account Number is required";
    } else if (!validateAccountNumber(formData.accountNumber)) {
      errors.accountNumber = "Account number must be 9-18 digits";
    }

    if (!formData.ifscCode.trim()) {
      errors.ifscCode = "IFSC Code is required";
    } else if (!validateIFSC(formData.ifscCode.toUpperCase())) {
      errors.ifscCode = "Please enter a valid IFSC code (e.g., SBIN0001234)";
    }

    if (!formData.branchName.trim()) {
      errors.branchName = "Branch Name is required";
    }

    if (!formData.panNumber.trim()) {
      errors.panNumber = "PAN Number is required";
    } else if (!validatePAN(formData.panNumber.toUpperCase())) {
      errors.panNumber = "Please enter a valid PAN number (e.g., ABCDE1234F)";
    }

    if (!formData.aadhaarNumber.trim()) {
      errors.aadhaarNumber = "Aadhaar Number is required";
    } else if (!validateAadhaar(formData.aadhaarNumber)) {
      errors.aadhaarNumber = "Aadhaar number must be exactly 12 digits";
    }

    if (formData.passportNumber && formData.passportNumber.length < 8) {
      errors.passportNumber = "Passport number must be at least 8 characters";
    }

    if (formData.drivingLicense && formData.drivingLicense.length < 10) {
      errors.drivingLicense =
        "Driving license number must be at least 10 characters";
    }

    if (formData.voterId && formData.voterId.length < 10) {
      errors.voterId = "Voter ID must be at least 10 characters";
    }

    return errors;
  };

  const validateEmergencyContact = () => {
    const errors = {};

    if (!formData.emergencyContactName.trim()) {
      errors.emergencyContactName = "Emergency Contact Name is required";
    }

    if (!formData.emergencyRelation.trim()) {
      errors.emergencyRelation = "Emergency Contact Relation is required";
    }

    if (!formData.emergencyMobile.trim()) {
      errors.emergencyMobile = "Emergency Mobile is required";
    } else if (!validateMobile(formData.emergencyMobile)) {
      errors.emergencyMobile =
        "Emergency mobile number must be exactly 10 digits";
    }

    if (!formData.emergencyAddress.trim()) {
      errors.emergencyAddress = "Emergency Address is required";
    }

    return errors;
  };

  const getCurrentSectionValidation = () => {
    const errors = {};
    let firstInvalidField = null;

    switch (activeStep) {
      case 0:
        const basicErrors = validateBasicInfo();
        Object.assign(errors, basicErrors);
        firstInvalidField = Object.keys(basicErrors)[0];
        break;
      case 1:
        const contactErrors = validateContactDetails();
        Object.assign(errors, contactErrors);
        firstInvalidField = Object.keys(contactErrors)[0];
        break;
      case 2:
        const employmentErrors = validateEmploymentDetails();
        Object.assign(errors, employmentErrors);
        firstInvalidField = Object.keys(employmentErrors)[0];
        break;
      case 3:
        const educationErrors = validateEducationDetails();
        Object.assign(errors, educationErrors);
        firstInvalidField = Object.keys(educationErrors)[0];
        break;
      case 4:
        const bankErrors = validateBankDetails();
        Object.assign(errors, bankErrors);
        firstInvalidField = Object.keys(bankErrors)[0];
        break;
      case 5:
        const emergencyErrors = validateEmergencyContact();
        Object.assign(errors, emergencyErrors);
        firstInvalidField = Object.keys(emergencyErrors)[0];
        break;
      default:
        break;
    }

    return { errors, firstInvalidField };
  };

  const scrollToInvalidField = (fieldName) => {
    if (fieldName && inputRefs.current[fieldName]) {
      setTimeout(() => {
        inputRefs.current[fieldName].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        if (inputRefs.current[fieldName].focus) {
          inputRefs.current[fieldName].focus();
        }
      }, 100);
    }
  };

  const handleViewCertificate = (certificate) => {
    setSelectedCertificate(certificate);
    setShowCertificateModal(true);
  };

  const handleCloseCertificateModal = () => {
    setShowCertificateModal(false);
    setSelectedCertificate(null);
  };


  const fetchWorkLocations = async () => {
    try {
      const companyKey = sessionStorage.getItem("companyKey");
      if (!companyKey) return;

      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8922_PayrollProduct_PayrollAddLocations_PayrollLocationDetails"
      );

      if (response.ok) {
        const data = await response.json();

        // Filter by companyKey and remove null/empty values
        const filteredLocations = data.filter(
          item =>
            item.companyKey === companyKey &&
            item.locationName &&
            item.locationName.trim() !== "" &&
            item.address &&
            item.address.trim() !== ""
        );

        // Format locations for dropdown
        const formattedLocations = filteredLocations.map(item => ({
          value: item.address,
          label: item.locationName,
          fullAddress: item.address
        }));

        setWorkLocations(formattedLocations);
      }
    } catch (error) {
      console.error("Error fetching work locations:", error);
    }
  };

  const fetchDropdownData = async () => {
    try {
      const companyKey = sessionStorage.getItem("companyKey");
      if (!companyKey) return;

      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8924_Payroll_DepartmentManagement_DepartmentList"
      );

      if (response.ok) {
        const data = await response.json();

        // Filter by companyKey AND filter out null/empty/undefined/"null" string values
        const filteredData = data.filter(item => {
          // Check if companyKey matches
          if (item.companyKey !== companyKey) return false;

          const isValidValue = (value) => {
            if (value === null || value === undefined) return false;
            if (typeof value !== 'string') return false;
            const strValue = value.trim().toLowerCase();
            return strValue !== "" && strValue !== "null";
          };
          // Only include items that have at least one valid field
          return isValidValue(item.department) ||
            isValidValue(item.designation) ||
            isValidValue(item.employmentType);
        });

        const departments = [...new Map(filteredData
          .filter(item => {
            if (!item.department) return false;
            if (typeof item.department !== 'string') return false;
            const dept = item.department.trim().toLowerCase();
            return dept !== "" && dept !== "null";
          })
          .map(item => [item.department.trim(), {
            value: item.department.trim(),
            label: item.department.trim()
          }])
        ).values()];

        const designations = [...new Map(filteredData
          .filter(item => {
            if (!item.designation) return false;
            if (typeof item.designation !== 'string') return false;
            const desig = item.designation.trim().toLowerCase();
            return desig !== "" && desig !== "null";
          })
          .map(item => [item.designation.trim(), {
            value: item.designation.trim(),
            label: item.designation.trim(),
            department: item.department || ""
          }])
        ).values()];

        const employmentTypes = [...new Map(filteredData
          .filter(item => {
            if (!item.employmentType) return false;
            if (typeof item.employmentType !== 'string') return false;
            const empType = item.employmentType.trim().toLowerCase();
            return empType !== "" && empType !== "null";
          })
          .map(item => [item.employmentType.trim(), {
            value: item.employmentType.trim(),
            label: item.employmentType.trim()
          }])
        ).values()];

        console.log("Filtered Departments:", departments);
        console.log("Filtered Designations:", designations);
        console.log("Filtered Employment Types:", employmentTypes);

        setDropdownData({
          departments,
          designations,
          employmentTypes,
        });

        if (formData.department) {
          const filteredDesignations = designations.filter(
            designation =>
              designation.department &&
              typeof designation.department === 'string' &&
              designation.department.trim().toLowerCase() ===
              formData.department.trim().toLowerCase()
          );
          setAvailableDesignations(filteredDesignations);
        }
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const saveDropdownValue = async (fieldType, value, companyKey, department = null) => {
    try {
      // Check if the value is null, empty, or any variation of "null"
      if (!value ||
        value.trim() === "" ||
        value.toLowerCase() === "null" ||
        value === "undefined" ||
        value === "Null" ||
        value === "NULL") {
        console.log(`${fieldType} is invalid or empty, not saving`);
        return;
      }

      // Check if companyKey exists
      if (!companyKey) {
        console.log("Company key not found");
        return;
      }

      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8924_Payroll_DepartmentManagement_DepartmentList"
      );

      if (response.ok) {
        const data = await response.json();

        // Case-insensitive duplicate check with null filtering
        const exists = data.some(item => {
          // Check if company key matches
          if (item.companyKey !== companyKey) return false;

          // Helper function to check if value is valid
          const isValidValue = (val) => {
            return val !== null &&
              val !== undefined &&
              val !== "null" &&
              val !== "Null" &&
              val !== "NULL" &&
              val.toString().trim() !== "";
          };

          if (fieldType === 'department') {
            return isValidValue(item.department) &&
              item.department.toLowerCase() === value.toLowerCase();
          } else if (fieldType === 'designation') {
            // Check if designation matches
            const designationMatch = isValidValue(item.designation) &&
              item.designation.toLowerCase() === value.toLowerCase();

            // Check if department matches (if provided)
            if (department) {
              return designationMatch &&
                isValidValue(item.department) &&
                item.department.toLowerCase() === department.toLowerCase();
            }
            return designationMatch;
          } else if (fieldType === 'employmentType') {
            return isValidValue(item.employmentType) &&
              item.employmentType.toLowerCase() === value.toLowerCase();
          }
          return false;
        });

        if (!exists) {
          // Create new entry object
          const newEntry = {
            companyKey,
            createdAt: new Date().toISOString(),
            isActive: "1"
          };

          // Add fields based on type, only if they're valid
          if (fieldType === 'department') {
            newEntry.department = value.trim();
            newEntry.designation = "";
            newEntry.employmentType = "";
          } else if (fieldType === 'designation') {
            newEntry.designation = value.trim();
            newEntry.department = department ? department.trim() : "";
            newEntry.employmentType = "";
          } else if (fieldType === 'employmentType') {
            newEntry.employmentType = value.trim();
            newEntry.department = "";
            newEntry.designation = "";
          }

          // Remove empty strings before sending
          Object.keys(newEntry).forEach(key => {
            if (newEntry[key] === "" || newEntry[key] === null || newEntry[key] === undefined) {
              delete newEntry[key];
            }
          });

          console.log("Saving new entry:", newEntry);

          const saveResponse = await fetch(
            "https://api.dremerz.net/api/DZ_8924_Payroll_DepartmentManagement_DepartmentList",
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(newEntry)
            }
          );

          if (saveResponse.ok) {
            console.log(`${fieldType} "${value}" saved successfully`);
            return true;
          } else {
            console.error(`Failed to save ${fieldType}:`, saveResponse.statusText);
            return false;
          }
        } else {
          console.log(`${fieldType} "${value}" already exists`);
          return true; // Already exists, so consider it "saved"
        }
      } else {
        console.error("Failed to fetch existing data");
        return false;
      }
    } catch (error) {
      console.error(`Error saving ${fieldType}:`, error);
      return false;
    }
  };

  const handleDepartmentChange = (e) => {
    const selectedDepartment = e.target.value;

    handleInputChange(e);

    setFormData((prev) => ({
      ...prev,
      jobTitle: "",
    }));

    // Filter designations and exclude null/empty values
    const filteredDesignations = dropdownData.designations.filter(
      designation =>
        designation.department &&
        designation.department.toString().trim().toLowerCase() ===
        selectedDepartment.toString().trim().toLowerCase() &&
        designation.value &&
        designation.value.toString().trim() !== ""
    );
    setAvailableDesignations(filteredDesignations);
  };


  useEffect(() => {
    const checkExistingRecord = async () => {
      if (!formData.employeeId) return;

      try {
        const response = await fetch(
          `https://api.dremerz.net/api/DZ_8922_Payroll_PayrollEmployeeBasicDetails_PayrollEmployeeDetails?employeeId=${formData.employeeId}`
        );

        if (response.ok) {
          const data = await response.json();
          if (data.length > 0) {
            setExistingRecordId(data[0].id);
            setExistingRecordData(data[0]);
            const cleanedData = {};
            Object.keys(data[0]).forEach((key) => {
              cleanedData[key] = handleNullValue(data[0][key]);
            });

            setFormData((prev) => ({
              ...prev,
              ...cleanedData,
            }));

            updateSectionStatus(cleanedData);
          }
        }
      } catch (error) {
        console.error("Error checking existing record:", error);
      }
    };

    checkExistingRecord();
  }, [formData.employeeId]);

  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const userId = sessionStorage.getItem("userMobile");
      if (!userId) {
        navigate("/signIn");
      }
    };

    checkAuth();
  }, [navigate]);

  const handleNullValue = (value) => {
    if (value === null || value === "null" || value === undefined) {
      return "";
    }
    return value;
  };

  const updateSectionStatus = (data) => {
    const newStatus = {
      basicInfo: !!(
        data.fullName &&
        data.employeeId &&
        data.dateOfBirth &&
        data.gender
      ),
      contactDetails: !!(
        data.personalEmail &&
        data.personalMobile &&
        data.currentAddress &&
        data.permanentAddress
      ),
      employmentDetails: !!(
        data.jobTitle &&
        data.department &&
        data.dateOfJoining &&
        data.workLocation
      ),
      educationDetails: !!(
        data.highestQualification &&
        data.university &&
        data.yearOfPassing &&
        data.specialization
      ),
      bankDetails: !!(
        data.bankName &&
        data.accountNumber &&
        data.ifscCode &&
        data.panNumber &&
        data.aadhaarNumber
      ),
      emergencyContact: !!(
        data.emergencyContactName &&
        data.emergencyRelation &&
        data.emergencyMobile &&
        data.emergencyAddress
      ),
    };
    setSectionStatus(newStatus);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "fullName") {
      return;
    }

    if (validationErrors[name]) {
      setValidationErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    let processedValue = value;
    if (name === "panNumber" || name === "ifscCode") {
      processedValue = value.toUpperCase();
    }
    if (
      name === "personalMobile" ||
      name === "alternateMobile" ||
      name === "emergencyMobile" ||
      name === "aadhaarNumber" ||
      name === "accountNumber"
    ) {
      processedValue = value.replace(/[^0-9]/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const searchEmployeesByName = async (name) => {
    if (!name.trim()) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollRegistration_PayrollRegistrationUsers"
      );

      if (response.ok) {
        const data = await response.json();
        const filteredData = data.filter((d) => d.companyKey === companyKey);

        const filteredResults = filteredData.filter(user =>
          user.full_name && user.full_name.toLowerCase().includes(name.toLowerCase()) ||
          user.mobile_number && user.mobile_number.toLowerCase().includes(name.toLowerCase()) ||
          user.employee_id && user.employee_id.toLowerCase().includes(name.toLowerCase())
        );

        setSearchResults(filteredResults);
        setShowSearchResults(filteredResults.length > 0);
      } else {
        console.error("Failed to fetch employee data");
        setSearchResults([]);
        setShowSearchResults(false);
      }
    } catch (error) {
      console.error("Error searching employees:", error);
      setSearchResults([]);
      setShowSearchResults(false);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setFormData(prev => ({
      ...prev,
      fullName: value
    }));

    if (value.length >= 2) {
      searchEmployeesByName(value);
    } else {
      setSearchResults([]);
      setShowSearchResults(false);
    }
  };

  const handleEmployeeSelect = (employee) => {
    setFormData(prev => ({
      ...prev,
      fullName: employee.full_name || "",
      employeeId: employee.employee_id || "",
      personalMobile: employee.mobile_number || "",
      personalEmail: employee.email || "",
      userId: employee.id || ""
    }));

    setSearchQuery(employee.full_name || "");
    setShowSearchResults(false);
    setSearchResults([]);
  };

  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex);
    setValidationErrors({});
  };

  const saveSectionData = async (sectionKey) => {
    const { errors, firstInvalidField } = getCurrentSectionValidation();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      showMyAlert({
        type: "danger",
        title: "Validation Error",
        message: "Please fill all required fields correctly before saving.",
        duration: 2500,
      });
      scrollToInvalidField(firstInvalidField);
      return false;
    }

    setLoading(true);
    setValidationErrors({});

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("employeeId", formData.employeeId);
      formDataToSend.append("userId", formData.userId);
      formDataToSend.append("userMobile", formData.userMobile);


      // formDataToSend.append("updatedSection", sectionKey);
      // formDataToSend.append(
      //   "sectionName",
      //   steps.find((step) => step.key === sectionKey)?.title || ""
      // );
      if (existingRecordId) {
        Object.keys(formData).forEach((key) => {
          if (
            key !== "photographFile" &&
            key !== "signatureFile" &&
            key !== "userId" &&
            key !== "userMobile" &&
            key !== "employeeId" &&
            key !== "photographPreview" &&
            key !== "signaturePreview"
          ) {
            formDataToSend.append(key, formData[key] || "");
          }
        });
        if (formData.photographFile) {
          formDataToSend.append("photograph", formData.photographFile);
        }
        if (formData.signatureFile) {
          formDataToSend.append("signature", formData.signatureFile);
        }
        certificateFiles.forEach((file, index) => {
          formDataToSend.append(`certificate_${index}`, file);
        });
      } else {
        switch (sectionKey) {
          case "basicInfo":
            formDataToSend.append("fullName", formData.fullName || "");
            formDataToSend.append("dateOfBirth", formData.dateOfBirth || "");
            formDataToSend.append("gender", formData.gender || "");
            formDataToSend.append(
              "maritalStatus",
              formData.maritalStatus || ""
            );
            formDataToSend.append("parentName", formData.parentName || "");
            formDataToSend.append("bloodGroup", formData.bloodGroup || "");
            formDataToSend.append("nationality", formData.nationality || "");
            if (formData.photographFile) {
              formDataToSend.append("photograph", formData.photographFile);
            }
            if (formData.signatureFile) {
              formDataToSend.append("signature", formData.signatureFile);
            }
            break;
          case "contactDetails":
            formDataToSend.append(
              "personalMobile",
              formData.personalMobile || ""
            );
            formDataToSend.append(
              "alternateMobile",
              formData.alternateMobile || ""
            );
            formDataToSend.append(
              "personalEmail",
              formData.personalEmail || ""
            );
            formDataToSend.append(
              "currentAddress",
              formData.currentAddress || ""
            );
            formDataToSend.append(
              "permanentAddress",
              formData.permanentAddress || ""
            );
            break;
          case "employmentDetails":
            formDataToSend.append("jobTitle", formData.jobTitle || "");
            formDataToSend.append("department", formData.department || "");
            formDataToSend.append(
              "reportingManager",
              formData.reportingManager || ""
            );
            formDataToSend.append(
              "reportingManagerEmpID",
              formData.reportingManagerEmpID || ""
            );
            formDataToSend.append(
              "dateOfJoining",
              formData.dateOfJoining || ""
            );
            formDataToSend.append("workLocation", formData.workLocation || "");
            formDataToSend.append(
              "employmentType",
              formData.employmentType || ""
            );
            formDataToSend.append(
              "probationPeriod",
              formData.probationPeriod || ""
            );
            formDataToSend.append("shiftTiming", formData.shiftTiming || "");
            break;
          case "educationDetails":
            formDataToSend.append(
              "highestQualification",
              formData.highestQualification || ""
            );
            formDataToSend.append("university", formData.university || "");
            formDataToSend.append(
              "yearOfPassing",
              formData.yearOfPassing || ""
            );
            formDataToSend.append(
              "specialization",
              formData.specialization || ""
            );
            formDataToSend.append(
              "certifications",
              formData.certifications || "[]"
            );
            formDataToSend.append(
              "previousCompany",
              formData.previousCompany || ""
            );
            formDataToSend.append(
              "previousDesignation",
              formData.previousDesignation || ""
            );
            formDataToSend.append(
              "previousDuration",
              formData.previousDuration || ""
            );
            formDataToSend.append(
              "leavingReason",
              formData.leavingReason || ""
            );
            formDataToSend.append("certifications", formData.certifications || "[]");
            certificateFiles.forEach((file, index) => {
              formDataToSend.append(`certification_file_${index}`, file);
            });
            break;
          case "bankDetails":
            formDataToSend.append("bankName", formData.bankName || "");
            formDataToSend.append(
              "accountHolderName",
              formData.accountHolderName || ""
            );
            formDataToSend.append(
              "accountNumber",
              formData.accountNumber || ""
            );
            formDataToSend.append("ifscCode", formData.ifscCode || "");
            formDataToSend.append("branchName", formData.branchName || "");
            formDataToSend.append("panNumber", formData.panNumber || "");
            formDataToSend.append(
              "aadhaarNumber",
              formData.aadhaarNumber || ""
            );
            formDataToSend.append(
              "passportNumber",
              formData.passportNumber || ""
            );
            formDataToSend.append(
              "drivingLicense",
              formData.drivingLicense || ""
            );
            formDataToSend.append("voterId", formData.voterId || "");
            break;
          case "emergencyContact":
            formDataToSend.append(
              "emergencyContactName",
              formData.emergencyContactName || ""
            );
            formDataToSend.append(
              "emergencyRelation",
              formData.emergencyRelation || ""
            );
            formDataToSend.append(
              "emergencyMobile",
              formData.emergencyMobile || ""
            );
            formDataToSend.append(
              "emergencyAddress",
              formData.emergencyAddress || ""
            );
            break;
        }
      }

      const url =
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollEmployeeBasicDetails_PayrollEmployeeDetails";
      const method = existingRecordId ? "PUT" : "POST";
      const finalUrl = existingRecordId ? `${url}/${existingRecordId}` : url;
      if (method === "POST") {
        formDataToSend.append("companyKey", companyKey);
      }

      const response = await fetch(finalUrl, {
        method: method,
        body: formDataToSend,
      });

      const formDataObj = Object.fromEntries(formDataToSend.entries());
      const result = await response.json();
      doAuditLog(existingRecordId ? "Update" : "Add", "Add Employees Detail", existingRecordId ? existingRecordData : "", formDataObj);

      if (
        response.ok &&
        (result.id || result.success || result.message === "Success")
      ) {
        if (!existingRecordId && result.id) {
          setExistingRecordId(result.id);
          setExistingRecordData(result);
        }

        if (sectionKey === "educationDetails" && result.uploadedCertificates) {
          setUploadedCertificates(result.uploadedCertificates);
          setCertificateFiles([]);
        }

        setSectionStatus((prev) => ({
          ...prev,
          [sectionKey]: true,
        }));

        showMyAlert({
          type: "success",
          title: "Success",
          message: `${steps.find((step) => step.key === sectionKey)?.title || "Section"
            } saved successfully!`,
          duration: 2500,
        });


        if (sectionKey === "emergencyContact") {
          navigate("/empdetailsunapproved");
        }

        return true;
      } else {
        showMyAlert({
          type: "danger",
          title: "Error",
          message: result.message || "Failed to save section data. Please try again.",
          duration: 2500,
        });
        return false;
      }
    } catch (error) {
      console.error("Error saving section data:", error);
      showMyAlert({
        type: "danger",
        title: "Error",
        message: error.message || "Failed to save section data. Please try again.",
        duration: 2500,
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  const searchManagersByName = async (name) => {
    if (!name.trim()) {
      setManagerSearchResults([]);
      setShowManagerSearchResults(false);
      return;
    }

    setIsSearchingManager(true);
    try {
      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollEmployeeBasicDetails_PayrollEmployeeDetails"
      );

      if (response.ok) {
        const data = await response.json();

        const filteredData = data.filter((d) => d.companyKey === companyKey);

        const filteredResults = filteredData.filter(
          (employee) =>
            employee.reportingManager &&
            employee.reportingManager.toLowerCase().includes(name.toLowerCase())
        );

        const uniqueResults = [
          ...new Map(
            filteredResults.map((emp) => [emp.reportingManager.toLowerCase(), emp])
          ).values(),
        ];

        setManagerSearchResults(uniqueResults);
        setShowManagerSearchResults(uniqueResults.length > 0);
      } else {
        setManagerSearchResults([]);
        setShowManagerSearchResults(false);
      }
    } catch (error) {
      console.error("Error searching managers:", error);
      setManagerSearchResults([]);
      setShowManagerSearchResults(false);
    } finally {
      setIsSearchingManager(false);
    }
  };


  const handleManagerSearchChange = (e) => {
    const value = e.target.value;
    setManagerSearchQuery(value);

    setFormData(prev => ({
      ...prev,
      reportingManager: value
    }));

    if (value.length >= 2) {
      searchManagersByName(value);
    } else {
      setManagerSearchResults([]);
      setShowManagerSearchResults(false);
    }
  };

  const handleManagerSelect = (manager) => {
    setFormData(prev => ({
      ...prev,
      reportingManager: manager.reportingManager || "",
      reportingManagerEmpID: manager.reportingManagerEmpID || ""
    }));

    setManagerSearchQuery(manager.reportingManager || "");
    setShowManagerSearchResults(false);
    setManagerSearchResults([]);
  };

  const handleSaveAndContinue = async () => {
    const saved = await saveSectionData(steps[activeStep].key);
    if (saved && activeStep < steps.length - 1) {
      setActiveStep(activeStep + 1);
    }
  };

  const handlePrevious = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
      setValidationErrors({});
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await saveSectionData(steps[activeStep].key);
  };

  const ProgressBar = () => (
    <div className="mb-1">
      <div className="d-flex justify-content-center position-relative">
        <div
          className="position-absolute bg-light rounded-pill"
          style={{
            height: "4px",
            width: "calc(100% - 100px)",
            top: "17px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
          }}
        >
          <div
            className="bg-success h-100 rounded-pill transition-all"
            style={{
              width: `${(activeStep / (steps.length - 1)) * 100}%`,
              transition: "width 0.4s ease-in-out",
            }}
          />
        </div>
        <div
          className="d-flex justify-content-between position-relative w-100 px-4"
          style={{ zIndex: 2 }}
        >
          {steps.map((step, index) => (
            <div
              key={step.id}
              className="d-flex flex-column align-items-center"
              style={{ cursor: "pointer", flex: "0 0 auto" }}
              onClick={() => handleStepClick(index)}
            >
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center shadow-sm ${sectionStatus[step.key]
                  ? "bg-success text-white border-success"
                  : index === activeStep
                    ? "bg-primary text-white"
                    : "bg-white text-muted border-2 border-light"
                  }`}
                style={{
                  width: "34px",
                  height: "34px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  border: "3px solid",
                  transition: "all 0.3s ease",
                  transform: index === activeStep ? "scale(1.1)" : "scale(1)",
                }}
              >
                {sectionStatus[step.key] ? (
                  <i className="fas fa-check" style={{ fontSize: "16px" }}></i>
                ) : (
                  <i className={step.icon} style={{ fontSize: "16px" }}></i>
                )}
              </div>
              <div
                className={`mt-2 text-center ${sectionStatus[step.key]
                  ? "text-success fw-bold"
                  : index === activeStep
                    ? " fw-bold"
                    : "text-muted fw-medium"
                  }`}
                style={{
                  fontSize: "11px",
                  maxWidth: "80px",
                  lineHeight: "1.2",
                  transition: "all 0.3s ease",
                }}
              >
                {step.title}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-3">
        <small className="text-muted fw-medium">
          <i className="fas fa-info-circle me-1"></i>
          Click on any section to navigate directly
        </small>
      </div>
    </div>
  );

  const renderBasicInfo = () => (
    <Card className="mb-2 border-0">
      <Card.Header className="border-0 py-4">
        <div className="d-flex align-items-center">
          <i className="fas fa-user me-3 fs-5"></i>
          <h5 className="mb-0 fw-bold">Basic Information</h5>
        </div>
      </Card.Header>
      <Card.Body className="p-4 text-start">
        <Row className="g-4">
          <Col md={4}>
            <Form.Group className="position-relative">
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-user me-2 "></i>
                Full Name *
              </Form.Label>
              <Form.Control
                type="text"
                name="fullName"
                value={searchQuery || handleNullValue(formData.fullName)}
                onChange={handleSearchChange}
                required
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.fullName}
                placeholder="Search employee by name"
                ref={(el) => (inputRefs.current.fullName = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.fullName}
              </Form.Control.Feedback>

              {/* Search Results Dropdown */}
              {showSearchResults && (
                <div
                  className="position-absolute w-100 bg-white border mt-1 rounded shadow-lg"
                  style={{ zIndex: 1050, maxHeight: '200px', overflowY: 'auto' }}
                >
                  {isSearching ? (
                    <div className="p-2 text-center">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Searching...
                    </div>
                  ) : (
                    searchResults.map((employee, index) => (
                      <div
                        key={employee.id || index}
                        className="p-2 border-bottom cursor-pointer hover-bg-light"
                        onClick={() => handleEmployeeSelect(employee)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="fw-semibold">{employee.full_name}</div>
                        <small className="text-muted">
                          ID: {employee.employee_id} | Mobile: {employee.mobile_number}
                        </small>
                      </div>
                    ))
                  )}
                </div>
              )}
              <Form.Text className="text-muted">
                Start typing to search existing employees
              </Form.Text>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-id-card me-2 "></i>
                Employee ID *
              </Form.Label>
              <Form.Control
                type="text"
                name="employeeId"
                value={handleNullValue(formData.employeeId)}
                onChange={handleInputChange}
                required
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.employeeId}
                placeholder="Enter employee ID"
                ref={(el) => (inputRefs.current.employeeId = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.employeeId}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-calendar me-2 "></i>
                Date of Birth *
              </Form.Label>
              <Form.Control
                type="date"
                name="dateOfBirth"
                value={handleNullValue(formData.dateOfBirth)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.dateOfBirth}
                ref={(el) => (inputRefs.current.dateOfBirth = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.dateOfBirth}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Photograph Upload with Preview */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Photograph</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handlePhotographUpload}
                className="mb-2"
                ref={photographInputRef}

              />
              {formData.photographPreview && (
                <div className="mt-2">
                  <p className="text-muted mb-2">Preview:</p>
                  <div className="border rounded p-2 d-inline-block">
                    <img
                      src={formData.photographPreview}
                      alt="Photograph preview"
                      style={{ maxWidth: '200px', maxHeight: '200px' }}
                      className="img-fluid"
                    />
                  </div>
                </div>
              )}
              {formData.photograph && !formData.photographPreview && (
                <img
                  src={`https://api.dremerz.net/uploads/${formData.photograph}`}
                  alt="Existing Photograph"
                  style={{ maxWidth: '200px', maxHeight: '200px' }}
                  className="img-fluid mt-2"
                />
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Signature</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleSignatureUpload}
                className="mb-2"
                ref={signatureInputRef}
              />
              {formData.signaturePreview && (
                <div className="mt-2">
                  <p className="text-muted mb-2">Preview:</p>
                  <div className="border rounded p-2 d-inline-block">
                    <img
                      src={formData.signaturePreview}
                      alt="Signature preview"
                      style={{ maxWidth: '200px', maxHeight: '100px' }}
                      className="img-fluid"
                    />
                  </div>
                </div>
              )}
              {formData.signature && !formData.signaturePreview && (
                <img
                  src={`https://api.dremerz.net/uploads/${formData.signature}`}
                  alt="Existing Signature"
                  style={{ maxWidth: '200px', maxHeight: '200px' }}
                  className="img-fluid mt-2"
                />
              )}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-venus-mars me-2 "></i>
                Gender *
              </Form.Label>
              <Form.Select
                name="gender"
                value={handleNullValue(formData.gender)}
                onChange={handleInputChange}
                required
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.gender}
                ref={(el) => (inputRefs.current.gender = el)}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {validationErrors.gender}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-flag me-2 "></i>
                Nationality *
              </Form.Label>
              <Form.Control
                type="text"
                name="nationality"
                value={handleNullValue(formData.nationality)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                placeholder="e.g., Indian"
                isInvalid={!!validationErrors.nationality}
                ref={(el) => (inputRefs.current.nationality = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.nationality}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-heart me-2 "></i>
                Marital Status
              </Form.Label>
              <Form.Select
                name="maritalStatus"
                value={handleNullValue(formData.maritalStatus)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
              >
                <option value="">Select Status</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-user-friends me-2 "></i>
                Parent Name
              </Form.Label>
              <Form.Control
                type="text"
                name="parentName"
                value={handleNullValue(formData.parentName)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                placeholder="Enter parent name"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-tint me-2 "></i>
                Blood Group
              </Form.Label>
              <Form.Select
                name="bloodGroup"
                value={handleNullValue(formData.bloodGroup)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="A1+">A1+</option>
                <option value="A1-">A1-</option>
                <option value="A2+">A2+</option>
                <option value="A2-">A2-</option>
                <option value="Bombay (hh)">Bombay (hh)</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const renderContactDetails = () => (
    <Card className="mb-4 border-0">
      <Card.Header
        className="border-0 py-4"
      >
        <div className="d-flex align-items-center">
          <i className="fas fa-address-book me-3 fs-5"></i>
          <h5 className="mb-0 fw-bold">Contact Details</h5>
        </div>
      </Card.Header>
      <Card.Body className="p-4 text-start">
        <Row className="g-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-phone me-2 "></i>
                Mobile Number *
              </Form.Label>
              <Form.Control
                type="tel"
                name="personalMobile"
                value={handleNullValue(formData.personalMobile)}
                onChange={handleInputChange}
                required
                className="form-control-lg border-2"
                maxLength="10"
                isInvalid={!!validationErrors.personalMobile}
                placeholder="Enter 10-digit mobile number"
                readOnly
                ref={(el) => (inputRefs.current.personalMobile = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.personalMobile}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-phone-alt me-2 "></i>
                Alternate Mobile
              </Form.Label>
              <Form.Control
                type="tel"
                name="alternateMobile"
                value={handleNullValue(formData.alternateMobile)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                maxLength="10"
                isInvalid={!!validationErrors.alternateMobile}
                placeholder="Enter alternate mobile number"
                ref={(el) => (inputRefs.current.alternateMobile = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.alternateMobile}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-envelope me-2 "></i>
                Work Email *
              </Form.Label>
              <Form.Control
                type="email"
                name="personalEmail"
                value={handleNullValue(formData.personalEmail)}
                onChange={handleInputChange}
                required
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.personalEmail}
                placeholder="Enter work email address"
                ref={(el) => (inputRefs.current.personalEmail = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.personalEmail}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark">
                <i className="fas fa-map-marker-alt me-2 "></i>
                Current Address *
              </Form.Label>
              <Form.Control
                as="textarea"
                name="currentAddress"
                value={handleNullValue(formData.currentAddress)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.currentAddress}
                placeholder="Enter current address"
                ref={(el) => (inputRefs.current.currentAddress = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.currentAddress}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark">
                <i className="fas fa-home me-2 "></i>
                Permanent Address *
              </Form.Label>
              <Form.Control
                as="textarea"
                name="permanentAddress"
                value={handleNullValue(formData.permanentAddress)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.permanentAddress}
                placeholder="Enter permanent address"
                ref={(el) => (inputRefs.current.permanentAddress = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.permanentAddress}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const renderEmploymentDetails = () => (
    <Card className="mb-4 border-0">
      <Card.Header className="border-0 py-4">
        <div className="d-flex align-items-center">
          <i className="fas fa-briefcase me-3 fs-5"></i>
          <h5 className="mb-0 fw-bold">Employment Details</h5>
        </div>
      </Card.Header>
      <Card.Body className="p-4 text-start">
        <Row className="g-4">
          {/* Department Field with Add Button */}
          <Col md={6}>
            <Form.Group className="position-relative">
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-building me-2"></i>
                Department *
              </Form.Label>
              <div className="d-flex gap-2">
                <div className="dropdown-custom flex-grow-1">
                  <Form.Control
                    type="text"
                    name="department"
                    value={handleNullValue(formData.department)}
                    onChange={handleDepartmentChange}
                    onClick={() => {
                      fetchDropdownData();
                      setShowDepartmentDropdown(!showDepartmentDropdown);
                      setShowDesignationDropdown(false);
                      setShowEmploymentTypeDropdown(false);
                    }}
                    onFocus={() => {
                      setShowDepartmentDropdown(true);
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowDepartmentDropdown(false), 300);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    required
                    className="form-control-lg border-2"
                    isInvalid={!!validationErrors.department}
                    placeholder="Click to select or type department"
                    ref={(el) => (inputRefs.current.department = el)}
                    autoComplete="off"
                  />
                  <div className="dropdown-arrow" onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}>
                    <i className={`fas fa-chevron-${showDepartmentDropdown ? 'up' : 'down'}`}></i>
                  </div>

                  {/* Department Dropdown Menu */}
                  {showDepartmentDropdown && (
                    <div
                      className="dropdown-menu-custom show"
                      style={{
                        maxHeight: '200px',
                        overflowY: 'auto',
                        zIndex: 1050,
                      }}
                    >
                      {dropdownData.departments.length > 0 ? (
                        dropdownData.departments.map((dept, index) => (
                          <div
                            key={index}
                            className="dropdown-item-custom"
                            onClick={() => {
                              setFormData(prev => ({
                                ...prev,
                                department: dept.label,
                                jobTitle: ""
                              }));
                              setShowDepartmentDropdown(false);

                              const filteredDesignations = dropdownData.designations.filter(
                                designation => designation.department === dept.label
                              );
                              setAvailableDesignations(filteredDesignations);

                              const companyKey = sessionStorage.getItem("companyKey");
                              if (companyKey) {
                                handleDepartmentChange({
                                  target: {
                                    name: 'department',
                                    value: dept.label
                                  }
                                });
                              }
                            }}
                          >
                            {dept.label}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-item-custom text-muted p-2">
                          No departments found. Type to create new.
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Add Department Button */}
                <Button
                  variant="primary"
                  className="px-3"
                  style={{ height: '48px' }}
                  onClick={() => {
                    const value = formData.department.trim();
                    const companyKey = sessionStorage.getItem("companyKey");

                    if (!value) {
                      showMyAlert({
                        type: "warning",
                        title: "Empty Field",
                        message: "Please enter a department name first.",
                        duration: 2500,
                      });
                      return;
                    }

                    if (companyKey) {
                      const exists = dropdownData.departments.some(
                        dept => dept.value.toLowerCase() === value.toLowerCase()
                      );

                      if (exists) {
                        showMyAlert({
                          type: "info",
                          title: "Already Exists",
                          message: `Department "${value}" already exists in the list.`,
                          duration: 2500,
                        });
                      } else {
                        setPendingDropdownValue({
                          type: 'department',
                          value: value,
                          department: null
                        });
                        setShowConfirmModal(true);
                      }
                    }
                  }}
                  disabled={!formData.department.trim()}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </div>
              <Form.Control.Feedback type="invalid">
                {validationErrors.department}
              </Form.Control.Feedback>
              <Form.Text className="text-muted">
                Select from list or type to create new department
              </Form.Text>
            </Form.Group>
          </Col>

          {/* Designation Field with Add Button */}
          <Col md={6}>
            <Form.Group className="position-relative">
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-user-tie me-2"></i>
                Designation *
              </Form.Label>
              <div className="d-flex gap-2">
                <div className="dropdown-custom flex-grow-1">
                  <Form.Control
                    type="text"
                    name="jobTitle"
                    value={handleNullValue(formData.jobTitle)}
                    onChange={handleInputChange}
                    onClick={() => {
                      setShowDesignationDropdown(!showDesignationDropdown);
                      setShowDepartmentDropdown(false);
                      setShowEmploymentTypeDropdown(false);
                    }}
                    onFocus={() => {
                      if (formData.department) {
                        setShowDesignationDropdown(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowDesignationDropdown(false), 300);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    required
                    className="form-control-lg border-2"
                    isInvalid={!!validationErrors.jobTitle}
                    placeholder={formData.department ? "Click to select or type designation" : "Select department first"}
                    disabled={!formData.department}
                    ref={(el) => (inputRefs.current.jobTitle = el)}
                    autoComplete="off"
                  />
                  <div className="dropdown-arrow" onClick={() => formData.department && setShowDesignationDropdown(!showDesignationDropdown)}>
                    <i className={`fas fa-chevron-${showDesignationDropdown ? 'up' : 'down'}`}></i>
                  </div>

                  {/* Designation Dropdown Menu */}
                  {showDesignationDropdown && formData.department && (
                    <div
                      className="dropdown-menu-custom show"
                      style={{
                        maxHeight: '200px',
                        overflowY: 'auto',
                        zIndex: 1050,
                      }}
                    >
                      {availableDesignations.length > 0 ? (
                        availableDesignations.map((designation, index) => (
                          <div
                            key={index}
                            className="dropdown-item-custom"
                            onClick={() => {
                              setFormData(prev => ({
                                ...prev,
                                jobTitle: designation.label
                              }));
                              setShowDesignationDropdown(false);

                              const companyKey = sessionStorage.getItem("companyKey");
                              if (companyKey && formData.department) {
                                handleInputChange({
                                  target: {
                                    name: 'jobTitle',
                                    value: designation.label
                                  }
                                });
                              }
                            }}
                          >
                            {designation.label}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-item-custom text-muted p-2">
                          No designations found for {formData.department}. Type to create new.
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Add Designation Button */}
                <Button
                  variant="primary"
                  className="px-3"
                  style={{ height: '48px' }}
                  onClick={() => {
                    const value = formData.jobTitle.trim();
                    const companyKey = sessionStorage.getItem("companyKey");

                    if (!formData.department) {
                      showMyAlert({
                        type: "warning",
                        title: "Department Required",
                        message: "Please select a department first.",
                        duration: 2500,
                      });
                      return;
                    }

                    if (!value) {
                      showMyAlert({
                        type: "warning",
                        title: "Empty Field",
                        message: "Please enter a designation name first.",
                        duration: 2500,
                      });
                      return;
                    }

                    if (companyKey && formData.department) {
                      const exists = availableDesignations.some(
                        d => d.value.toLowerCase() === value.toLowerCase()
                      );

                      if (exists) {
                        showMyAlert({
                          type: "info",
                          title: "Already Exists",
                          message: `Designation "${value}" already exists for ${formData.department}.`,
                          duration: 2500,
                        });
                      } else {
                        setPendingDropdownValue({
                          type: 'designation',
                          value: value,
                          department: formData.department
                        });
                        setShowConfirmModal(true);
                      }
                    }
                  }}
                  disabled={!formData.department || !formData.jobTitle.trim()}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </div>
              <Form.Control.Feedback type="invalid">
                {validationErrors.jobTitle}
              </Form.Control.Feedback>
              <Form.Text className="text-muted">
                {formData.department
                  ? "Select from list or type to create new designation"
                  : "Select department first"}
              </Form.Text>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-calendar-check me-2"></i>
                Date of Joining *
              </Form.Label>
              <Form.Control
                type="date"
                name="dateOfJoining"
                value={handleNullValue(formData.dateOfJoining)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.dateOfJoining}
                ref={(el) => (inputRefs.current.dateOfJoining = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.dateOfJoining}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-map-pin me-2"></i>
                Work Location *
              </Form.Label>
              <Form.Select
                name="workLocation"
                value={handleNullValue(formData.workLocation)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.workLocation}
                ref={(el) => (inputRefs.current.workLocation = el)}
              >
                <option value="">Select Work Location</option>
                {workLocations.map((location, index) => (
                  <option key={index} value={location.fullAddress}>
                    {location.label} - {location.fullAddress.substring(0, 50)}...
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {validationErrors.workLocation}
              </Form.Control.Feedback>
              {formData.workLocation && (
                <Form.Text className="text-muted">
                  Selected: {formData.workLocation}
                </Form.Text>
              )}
            </Form.Group>
          </Col>

          {/* Employment Type Field with Add Button */}
          <Col md={6}>
            <Form.Group className="position-relative">
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-clipboard-list me-2"></i>
                Employment Type
              </Form.Label>
              <div className="d-flex gap-2">
                <div className="dropdown-custom flex-grow-1">
                  <Form.Control
                    type="text"
                    name="employmentType"
                    value={handleNullValue(formData.employmentType)}
                    onChange={handleInputChange}
                    onClick={() => {
                      setShowEmploymentTypeDropdown(!showEmploymentTypeDropdown);
                      setShowDepartmentDropdown(false);
                      setShowDesignationDropdown(false);
                    }}
                    onFocus={() => {
                      setShowEmploymentTypeDropdown(true);
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowEmploymentTypeDropdown(false), 300);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    className="form-control-lg border-2"
                    placeholder="Click to select or type employment type"
                    autoComplete="off"
                  />
                  <div className="dropdown-arrow" onClick={() => setShowEmploymentTypeDropdown(!showEmploymentTypeDropdown)}>
                    <i className={`fas fa-chevron-${showEmploymentTypeDropdown ? 'up' : 'down'}`}></i>
                  </div>

                  {/* Employment Type Dropdown Menu */}
                  {showEmploymentTypeDropdown && (
                    <div
                      className="dropdown-menu-custom show"
                      style={{
                        maxHeight: '200px',
                        overflowY: 'auto',
                        zIndex: 1050,
                      }}
                    >
                      {dropdownData.employmentTypes.length > 0 ? (
                        dropdownData.employmentTypes.map((empType, index) => (
                          <div
                            key={index}
                            className="dropdown-item-custom"
                            onClick={() => {
                              setFormData(prev => ({
                                ...prev,
                                employmentType: empType.label
                              }));
                              setShowEmploymentTypeDropdown(false);

                              const companyKey = sessionStorage.getItem("companyKey");
                              if (companyKey) {
                                handleInputChange({
                                  target: {
                                    name: 'employmentType',
                                    value: empType.label
                                  }
                                });
                              }
                            }}
                          >
                            {empType.label}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-item-custom text-muted p-2">
                          No employment types found. Type to create new.
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Add Employment Type Button */}
                <Button
                  variant="primary"
                  className="px-3"
                  style={{ height: '48px' }}
                  onClick={() => {
                    const value = formData.employmentType.trim();
                    const companyKey = sessionStorage.getItem("companyKey");

                    if (!value) {
                      showMyAlert({
                        type: "warning",
                        title: "Empty Field",
                        message: "Please enter an employment type first.",
                        duration: 2500,
                      });
                      return;
                    }

                    if (companyKey) {
                      const exists = dropdownData.employmentTypes.some(
                        et => et.value.toLowerCase() === value.toLowerCase()
                      );

                      if (exists) {
                        showMyAlert({
                          type: "info",
                          title: "Already Exists",
                          message: `Employment type "${value}" already exists in the list.`,
                          duration: 2500,
                        });
                      } else {
                        setPendingDropdownValue({
                          type: 'employment type',
                          value: value,
                          department: null
                        });
                        setShowConfirmModal(true);
                      }
                    }
                  }}
                  disabled={!formData.employmentType.trim()}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </div>
              <Form.Text className="text-muted">
                Select from list or type to create new employment type
              </Form.Text>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-hourglass-half me-2"></i>
                Probation Period (months)
              </Form.Label>
              <Form.Control
                type="number"
                name="probationPeriod"
                value={handleNullValue(formData.probationPeriod)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                placeholder="Enter probation period"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="position-relative">
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-user-shield me-2"></i>
                Reporting Manager
              </Form.Label>
              <Form.Control
                type="text"
                name="reportingManager"
                value={managerSearchQuery || handleNullValue(formData.reportingManager)}
                onChange={handleManagerSearchChange}
                className="form-control-lg border-2"
                placeholder="Search manager by name or enter manually"
              />

              {/* Manager Search Results Dropdown */}
              {showManagerSearchResults && (
                <div
                  className="position-absolute w-100 bg-white border mt-1 rounded shadow-lg"
                  style={{ zIndex: 1050, maxHeight: '200px', overflowY: 'auto' }}
                >
                  {isSearchingManager ? (
                    <div className="p-2 text-center">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Searching...
                    </div>
                  ) : (
                    managerSearchResults.map((manager, index) => (
                      <div
                        key={manager.id || index}
                        className="p-2 border-bottom cursor-pointer hover-bg-light"
                        onClick={() => handleManagerSelect(manager)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="fw-semibold">{manager.reportingManager}</div>
                        <small className="text-muted">
                          ID: {manager.reportingManagerEmpID}
                        </small>
                      </div>
                    ))
                  )}
                </div>
              )}
              <Form.Text className="text-muted">
                Start typing to search or enter manually
              </Form.Text>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-id-badge me-2"></i>
                Reporting Manager EmpID
              </Form.Label>
              <Form.Control
                type="text"
                name="reportingManagerEmpID"
                value={handleNullValue(formData.reportingManagerEmpID)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                placeholder="Enter manager employee ID"
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const renderEducationDetails = () => {
    const handleCertificationChange = (e) => {
      const { name, value } = e.target;
      setNewCertification((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleFileChange = (e) => {
      if (e.target.files && e.target.files[0]) {
        const file = e.target.files[0];

        setNewCertification((prev) => ({
          ...prev,
          file: file,
          fileName: file.name, // Keep original name for display
        }));
      }
    };

    const addCertification = () => {
      if (newCertification.name && newCertification.file) {
        const certificationData = {
          name: newCertification.name,
          fileName: newCertification.fileName,
          file: newCertification.file,
        };

        const updatedCertifications = [...certifications, certificationData];
        setCertifications(updatedCertifications);
        setCertificateFiles((prev) => [...prev, newCertification.file]);
        const backendCertifications = updatedCertifications.map(
          (cert) => cert.name
        );

        setFormData((prev) => ({
          ...prev,
          certifications: JSON.stringify(backendCertifications),
        }));

        setNewCertification({
          name: "",
          file: null,
          fileName: "",
        });
        CertFieldRef.current.value = "";
      }
    };

    const removeCertification = (index) => {
      const updatedCertifications = certifications.filter(
        (_, i) => i !== index
      );
      setCertifications(updatedCertifications);
      const updatedFiles = certificateFiles.filter((_, i) => i !== index);
      setCertificateFiles(updatedFiles);
      const backendCertifications = updatedCertifications.map(
        (cert) => cert.name
      );

      setFormData((prev) => ({
        ...prev,
        certifications: JSON.stringify(backendCertifications),
      }));
    };
    const renderCertificationList = () => {
      if (certifications.length === 0) return null;

      return (
        <div className="mt-4">
          <h6 className="fw-semibold text-dark mb-3">Added Certifications:</h6>
          <div className="row">
            {certifications.map((cert, index) => (
              <div key={index} className="col-md-6 mb-2">
                <div className="d-flex justify-content-between align-items-center p-3 bg-white rounded-3 border">
                  <div>
                    <span className="fw-semibold text-dark">{cert.name}</span>
                  </div>
                  <div>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleViewCertificate(cert)}
                      className="me-2"
                    >
                      View
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removeCertification(index)}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    };

    return (
      <Card className="mb-4 border-0">
        <Card.Header
          className="border-0 py-4"
        >
          <div className="d-flex align-items-center">
            <i className="fas fa-graduation-cap me-3 fs-5"></i>
            <h5 className="mb-0 fw-bold">Education Details</h5>
          </div>
        </Card.Header>
        <Card.Body className="p-4 text-start">
          <Row className="g-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  <i className="fas fa-certificate me-2"></i>
                  Highest Qualification *
                </Form.Label>
                <Form.Control
                  type="text"
                  name="highestQualification"
                  value={handleNullValue(formData.highestQualification)}
                  onChange={handleInputChange}
                  className="form-control-lg border-2"
                  isInvalid={!!validationErrors.highestQualification}
                  placeholder="e.g., B.Tech, MBA, etc."
                  ref={(el) => (inputRefs.current.highestQualification = el)}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.highestQualification}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  <i className="fas fa-university me-2"></i>
                  University/Institute *
                </Form.Label>
                <Form.Control
                  type="text"
                  name="university"
                  value={handleNullValue(formData.university)}
                  onChange={handleInputChange}
                  className="form-control-lg border-2"
                  isInvalid={!!validationErrors.university}
                  placeholder="Enter university name"
                  ref={(el) => (inputRefs.current.university = el)}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.university}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  <i className="fas fa-calendar-alt me-2"></i>
                  Year of Passing *
                </Form.Label>
                <Form.Control
                  type="number"
                  name="yearOfPassing"
                  value={handleNullValue(formData.yearOfPassing)}
                  onChange={handleInputChange}
                  min="1950"
                  max="2030"
                  className="form-control-lg border-2"
                  isInvalid={!!validationErrors.yearOfPassing}
                  placeholder="Enter passing year"
                  ref={(el) => (inputRefs.current.yearOfPassing = el)}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.yearOfPassing}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  <i className="fas fa-book me-2"></i>
                  Specialization *
                </Form.Label>
                <Form.Control
                  type="text"
                  name="specialization"
                  value={handleNullValue(formData.specialization)}
                  onChange={handleInputChange}
                  className="form-control-lg border-2"
                  isInvalid={!!validationErrors.specialization}
                  placeholder="Enter specialization"
                  ref={(el) => (inputRefs.current.specialization = el)}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.specialization}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={12}>
              <div className="border rounded-3 p-4 bg-light">
                <h6 className="fw-bold mb-3">
                  <i className="fas fa-award me-2"></i>
                  Certifications
                </h6>
                <Row className="g-3">
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-dark mb-2">
                        Certification Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={newCertification.name}
                        onChange={handleCertificationChange}
                        placeholder="e.g., PMP Certification"
                        className="border-2"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label className="fw-semibold text-dark mb-2">
                        Certificate PDF
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={handleFileChange}
                        className="border-2"
                        ref={CertFieldRef}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      variant="warning"
                      className="fw-bold"
                      onClick={addCertification}
                      disabled={
                        !newCertification.name || !newCertification.file
                      }
                    >
                      <i className="fas fa-plus me-1"></i>
                      Add
                    </Button>
                  </Col>
                </Row>

                {/* Updated certification list rendering */}
                {renderCertificationList()}
              </div>
            </Col>

            <Col md={12}>
              <hr className="my-4" />
              <h6 className="fw-bold mb-3">
                <i className="fas fa-building me-2"></i>
                Previous Employment (Optional)
              </h6>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  Previous Company
                </Form.Label>
                <Form.Control
                  type="text"
                  name="previousCompany"
                  value={handleNullValue(formData.previousCompany)}
                  onChange={handleInputChange}
                  className="form-control-lg border-2"
                  placeholder="Enter previous company name"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  Previous Designation
                </Form.Label>
                <Form.Control
                  type="text"
                  name="previousDesignation"
                  value={handleNullValue(formData.previousDesignation)}
                  onChange={handleInputChange}
                  className="form-control-lg border-2"
                  placeholder="Enter previous designation"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  Duration
                </Form.Label>
                <Form.Control
                  type="text"
                  name="previousDuration"
                  value={handleNullValue(formData.previousDuration)}
                  onChange={handleInputChange}
                  placeholder="e.g., 2 years 3 months"
                  className="form-control-lg border-2"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold text-dark mb-2">
                  Reason for Leaving
                </Form.Label>
                <Form.Control
                  type="text"
                  name="leavingReason"
                  value={handleNullValue(formData.leavingReason)}
                  onChange={handleInputChange}
                  className="form-control-lg border-2"
                  placeholder="Enter reason for leaving"
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  const renderBankDetails = () => (
    <Card className="mb-4 border-0">
      <Card.Header
        className="border-0 py-4"
      >
        <div className="d-flex align-items-center">
          <i className="fas fa-university me-3 fs-5"></i>
          <h5 className="mb-0 fw-bold">Bank Details</h5>
        </div>
      </Card.Header>
      <Card.Body className="p-4 text-start">
        <Row className="g-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-building-columns me-2 text-dark"></i>
                Bank Name *
              </Form.Label>
              <Form.Control
                type="text"
                name="bankName"
                value={handleNullValue(formData.bankName)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.bankName}
                placeholder="Enter bank name"
                ref={(el) => (inputRefs.current.bankName = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.bankName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-user-circle me-2 text-dark"></i>
                Account Holder Name *
              </Form.Label>
              <Form.Control
                type="text"
                name="accountHolderName"
                value={handleNullValue(formData.accountHolderName)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.accountHolderName}
                placeholder="Enter account holder name"
                ref={(el) => (inputRefs.current.accountHolderName = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.accountHolderName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-credit-card me-2 text-dark"></i>
                Account Number *
              </Form.Label>
              <Form.Control
                type="text"
                name="accountNumber"
                value={handleNullValue(formData.accountNumber)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.accountNumber}
                placeholder="Enter account number"
                ref={(el) => (inputRefs.current.accountNumber = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.accountNumber}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-code me-2 text-dark"></i>
                IFSC Code *
              </Form.Label>
              <Form.Control
                type="text"
                name="ifscCode"
                value={handleNullValue(formData.ifscCode)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.ifscCode}
                placeholder="e.g., SBIN0001234"
                ref={(el) => (inputRefs.current.ifscCode = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.ifscCode}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-map-pin me-2 text-dark"></i>
                Branch Name *
              </Form.Label>
              <Form.Control
                type="text"
                name="branchName"
                value={handleNullValue(formData.branchName)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.branchName}
                placeholder="Enter branch name"
                ref={(el) => (inputRefs.current.branchName = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.branchName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-id-card-alt me-2 text-dark"></i>
                PAN Number *
              </Form.Label>
              <Form.Control
                type="text"
                name="panNumber"
                value={handleNullValue(formData.panNumber)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                maxLength="10"
                isInvalid={!!validationErrors.panNumber}
                placeholder="e.g., ABCDE1234F"
                style={{ textTransform: "uppercase" }}
                ref={(el) => (inputRefs.current.panNumber = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.panNumber}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-fingerprint me-2 text-dark"></i>
                Aadhaar Number *
              </Form.Label>
              <Form.Control
                type="text"
                name="aadhaarNumber"
                value={handleNullValue(formData.aadhaarNumber)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                maxLength="12"
                isInvalid={!!validationErrors.aadhaarNumber}
                placeholder="Enter 12-digit Aadhaar number"
                ref={(el) => (inputRefs.current.aadhaarNumber = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.aadhaarNumber}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={12}>
            <hr className="my-4" />
            <h6 className="fw-bold text-dark mb-3">
              <i className="fas fa-passport me-2"></i>
              Other Documents (Optional)
            </h6>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-passport me-2 text-dark"></i>
                Passport Number
              </Form.Label>
              <Form.Control
                type="text"
                name="passportNumber"
                value={handleNullValue(formData.passportNumber)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.passportNumber}
                placeholder="Enter passport number"
                ref={(el) => (inputRefs.current.passportNumber = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.passportNumber}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-car me-2 text-dark"></i>
                Driving License
              </Form.Label>
              <Form.Control
                type="text"
                name="drivingLicense"
                value={handleNullValue(formData.drivingLicense)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.drivingLicense}
                placeholder="Enter driving license number"
                ref={(el) => (inputRefs.current.drivingLicense = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.drivingLicense}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-vote-yea me-2 text-dark"></i>
                Voter ID
              </Form.Label>
              <Form.Control
                type="text"
                name="voterId"
                value={handleNullValue(formData.voterId)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.voterId}
                placeholder="Enter voter ID number"
                ref={(el) => (inputRefs.current.voterId = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.voterId}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const renderEmergencyContact = () => (
    <Card className="mb-4 border-0">
      <Card.Header
        className="border-0 py-4"
      >
        <div className="d-flex align-items-center">
          <i className="fas fa-phone-alt me-3 fs-5"></i>
          <h5 className="mb-0 fw-bold">Emergency Contact</h5>
        </div>
      </Card.Header>
      <Card.Body className="p-4 text-start">
        <Row className="g-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-user me-2"></i>
                Emergency Contact Name *
              </Form.Label>
              <Form.Control
                type="text"
                name="emergencyContactName"
                value={handleNullValue(formData.emergencyContactName)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.emergencyContactName}
                placeholder="Enter emergency contact name"
                ref={(el) => (inputRefs.current.emergencyContactName = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.emergencyContactName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-users me-2"></i>
                Relation *
              </Form.Label>
              <Form.Select
                name="emergencyRelation"
                value={handleNullValue(formData.emergencyRelation)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.emergencyRelation}
                ref={(el) => (inputRefs.current.emergencyRelation = el)}
              >
                <option value="">Select Relation</option>
                <option value="Father">Father</option>
                <option value="Mother">Mother</option>
                <option value="Spouse">Spouse</option>
                <option value="Brother">Brother</option>
                <option value="Sister">Sister</option>
                <option value="Friend">Friend</option>
                <option value="Other">Other</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {validationErrors.emergencyRelation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-phone me-2"></i>
                Emergency Mobile *
              </Form.Label>
              <Form.Control
                type="tel"
                name="emergencyMobile"
                value={handleNullValue(formData.emergencyMobile)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                maxLength="10"
                isInvalid={!!validationErrors.emergencyMobile}
                placeholder="Enter emergency mobile number"
                ref={(el) => (inputRefs.current.emergencyMobile = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.emergencyMobile}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold text-dark mb-2">
                <i className="fas fa-map-marker-alt me-2"></i>
                Emergency Address *
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="emergencyAddress"
                value={handleNullValue(formData.emergencyAddress)}
                onChange={handleInputChange}
                className="form-control-lg border-2"
                isInvalid={!!validationErrors.emergencyAddress}
                placeholder="Enter emergency contact address"
                ref={(el) => (inputRefs.current.emergencyAddress = el)}
              />
              <Form.Control.Feedback type="invalid">
                {validationErrors.emergencyAddress}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const renderCurrentSection = () => {
    switch (activeStep) {
      case 0:
        return renderBasicInfo();
      case 1:
        return renderContactDetails();
      case 2:
        return renderEmploymentDetails();
      case 3:
        return renderEducationDetails();
      case 4:
        return renderBankDetails();
      case 5:
        return renderEmergencyContact();
      default:
        return null;
    }
  };

  return (
    <Container fluid className="min-vh-100 bg-light py-4 mt-0">
      <div className="max-width-container mx-auto">
        {/* Header */}
        <Card className="p-3">
          <div className="p-2 mb-1">
            <h5 className=" fw-bold text-dark mb-1">
              <i className="fas fa-user-plus me-3"></i>
              Employee Details Form
            </h5>
            <p className="lead text-muted">
              Complete employee information step by step
            </p>
          </div>

          <ProgressBar />
        </Card>


        {/* Form */}
        <Form onSubmit={handleSubmit}>
          {renderCurrentSection()}

          {/* Navigation Buttons */}
          <Card className="border-0">
            <Card.Body className="p-3">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
                <Button
                  variant="outline-secondary"
                  onClick={handlePrevious}
                  disabled={activeStep === 0 || loading}
                  className="fw-bold px-3 py-2 px-md-4 py-md-2 w-25 w-md-auto"
                >
                  <i className="fas fa-chevron-left me-2"></i>
                  Previous
                </Button>

                <div className="text-center">
                  <small className="text-muted fw-medium">
                    Step {activeStep + 1} of {steps.length}
                  </small>
                </div>

                {activeStep < steps.length - 1 ? (
                  <Button
                    variant="primary"
                    onClick={handleSaveAndContinue}
                    disabled={loading}
                    className="fw-bold px-3 py-2 px-md-4 py-md-2 w-25 w-md-auto"
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      <>
                        Save & Continue
                        <i className="fas fa-chevron-right ms-2"></i>
                      </>
                    )}
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    type="submit"
                    disabled={loading}
                    className="fw-bold px-3 py-2 px-md-4 py-md-2 w-25 w-md-auto"
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save me-2"></i>
                        Save Details
                      </>
                    )}
                  </Button>
                )}
              </div>
            </Card.Body>
          </Card>
        </Form>
      </div>

      {/* Certificate View Modal */}
      <Modal
        show={showCertificateModal}
        onHide={handleCloseCertificateModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-certificate me-2"></i>
            {selectedCertificate?.name || 'Certificate'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {selectedCertificate ? (
            <div>
              {selectedCertificate.file?.type === 'application/pdf' ? (
                <>
                  <object
                    data={URL.createObjectURL(selectedCertificate.file)}
                    type="application/pdf"
                    width="100%"
                    height="500px"
                    className="border rounded"
                  >
                    <p className="text-muted">
                      PDF preview not available. Please download to view.
                    </p>
                  </object>

                  {/* <div className="mt-3">
                    <Button
                      variant="primary"
                      onClick={() => {
                        const url = URL.createObjectURL(selectedCertificate.file);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = selectedCertificate.fileName || 'certificate.pdf';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                      }}
                    >
                      <i className="fas fa-download me-2"></i>
                      Download PDF
                    </Button>
                  </div> */}
                </>
              ) : selectedCertificate.file?.type.startsWith('image/') ? (
                <>
                  <img
                    src={URL.createObjectURL(selectedCertificate.file)}
                    alt={selectedCertificate.name}
                    style={{ maxWidth: '100%', maxHeight: '500px' }}
                    className="img-fluid border rounded"
                  />

                  <div className="mt-3">
                    <Button
                      variant="primary"
                      onClick={() => {
                        const url = URL.createObjectURL(selectedCertificate.file);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = selectedCertificate.fileName || 'certificate.jpg';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                      }}
                    >
                      <i className="fas fa-download me-2"></i>
                      Download Image
                    </Button>
                  </div>
                </>
              ) : (
                <div>
                  <p className="text-muted mb-3">
                    File type not supported for preview.
                  </p>
                  <Button
                    variant="primary"
                    onClick={() => {
                      const url = URL.createObjectURL(selectedCertificate.file);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = selectedCertificate.fileName || 'certificate';
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }}
                  >
                    <i className="fas fa-download me-2"></i>
                    Download File
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <p className="text-muted">No certificate selected.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCertificateModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Confirmation Modal for Adding New Dropdown Values */}
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-question-circle me-2 text-warning"></i>
            Confirm New Entry
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center py-3">
            <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
            <h5 className="mt-3 mb-2">Add New {pendingDropdownValue.type}?</h5>
            <p className="text-muted mb-0">
              "<strong>{pendingDropdownValue.value}</strong>" is not in the list.
            </p>
            <p className="text-muted">
              Do you want to add it as a new {pendingDropdownValue.type}?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowConfirmModal(false);
              // Clear the input
              if (pendingDropdownValue.type === 'department') {
                setFormData(prev => ({ ...prev, department: "", jobTitle: "" }));
              } else if (pendingDropdownValue.type === 'designation') {
                setFormData(prev => ({ ...prev, jobTitle: "" }));
              } else if (pendingDropdownValue.type === 'employment type') {
                setFormData(prev => ({ ...prev, employmentType: "" }));
              }
              setPendingDropdownValue({ type: '', value: '', department: null });
            }}
          >
            <i className="fas fa-times me-2"></i>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              const companyKey = sessionStorage.getItem("companyKey");
              const { type, value, department } = pendingDropdownValue;

              let apiType = type;
              if (type === 'employment type') {
                apiType = 'employmentType';
              }

              const saved = await saveDropdownValue(apiType, value, companyKey, department);

              if (saved) {
                await fetchDropdownData();
                setShowConfirmModal(false);
                setPendingDropdownValue({ type: '', value: '', department: null });

                showMyAlert({
                  type: "success",
                  title: "Success",
                  message: `New ${type} "${value}" added successfully!`,
                  duration: 2500,
                });
              } else {
                showMyAlert({
                  type: "danger",
                  title: "Error",
                  message: `Failed to add new ${type}. Please try again.`,
                  duration: 2500,
                });
              }
            }}
          >
            <i className="fas fa-check me-2"></i>
            Yes, Add It
          </Button>
        </Modal.Footer>
      </Modal>


      <style jsx>{`
        .max-width-container {
          max-width: 1200px;
        }

        .bg-gradient-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .bg-gradient-info {
          background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
        }

        .bg-gradient-success {
          background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
        }

        .bg-gradient-warning {
          background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
        }

        .bg-gradient-dark {
          background: linear-gradient(135deg, #2d3436 0%, #636e72 100%);
        }

        .bg-gradient-danger {
          background: linear-gradient(135deg, #fd79a8 0%, #e84393 100%);
        }

        .form-control-lg {
          padding: 0.75rem 1rem;
          font-size: 1rem;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
        }

        .card {
          transition: all 0.3s ease;
        }

        .card:hover {
          transform: translateY(-2px);
        }

        .transition-all {
          transition: all 0.3s ease;
        }

        .shadow-lg {
          box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
        }

        .fw-semibold {
          font-weight: 600 !important;
        }

        @media (max-width: 768px) {
          .max-width-container {
            padding: 0 1rem;
          }

          .display-4 {
            font-size: 2rem;
          }

          .d-flex.justify-content-between.px-4 {
            flex-wrap: wrap;
            gap: 1rem;
          }

          .d-flex.justify-content-between.px-4 > div {
            min-width: 60px;
            text-align: center;
          }
        }
      `}</style>
    </Container>
  );
};

export default AddEmployeeDetails;